var _defs, _path, _path2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilmoraLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c3a4e;fill-rule:evenodd;}.cls-2{fill:#fff;}.cls-3{fill:#55e5c5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "filmora") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.08,0H94.8a28.17,28.17,0,0,1,28.08,28.08V94.8A28.17,28.17,0,0,1,94.8,122.88H28.08A28.17,28.17,0,0,1,0,94.8V28.08A28.17,28.17,0,0,1,28.08,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46,55.24,29.32,38.55,49.94,17.91,70.55,38.54,46.92,62.21l-.11-.12A5.58,5.58,0,0,0,46,55.24Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "93.58 61.27 49.92 104.97 29.3 84.34 72.96 40.63 93.58 61.27 93.58 61.27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilmoraLogo);
export default __webpack_public_path__ + "static/media/filmora_logo.5ee441be73663023a04414f05dea77e9.svg";
export { ForwardRef as ReactComponent };